<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex justify-content-between align-items-center modal-header">
              <div class="col-lg-auto">
                <h5 class="modal-title d-flex align-items-center">
                  <i class='ri-folder-settings-line me-1 font-20 text-primary'></i>
                  {{projectForm?.value?.id?'Update':'Add'}} Project
                </h5>
              </div>
            </div>
            <form [formGroup]="projectForm" (ngSubmit)="saveProject(inProgress)">
              <div class="modal-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label for="name" class="form-label">Project Name<b class="text-secondary">*</b></label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-file'></i></span>
                      <input type="text" class="form-control ps-1" id="name" placeholder="Enter project name"
                        [ngClass]="{'is-invalid': submitted && p?.name?.errors}" formControlName="name"
                        autocomplete="off" />
                      <div class="invalid-feedback" *ngIf="submitted && p?.name.errors">
                        <span *ngIf="p?.name?.errors.required">Please provide a valid project name.</span>
                        <span *ngIf="p?.name?.errors.pattern">Only alphanumeric characters are allowed.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="code" class="form-label">Project Code<b class="text-secondary">*</b></label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-barcode-reader'></i></span>
                      <input type="text" class="form-control ps-1" id="code" placeholder="Enter project code"
                        [value]="p['code'].value | uppercase" [ngClass]="{'is-invalid': submitted && p?.code?.errors}"
                        formControlName="code" autocomplete="off" />
                      <div class="invalid-feedback" *ngIf="submitted && p?.code.errors">
                        <span *ngIf="p?.code?.errors.required">Please provide a valid project code.</span>
                        <span *ngIf="p?.code?.errors.pattern">Only alphanumeric characters are allowed.</span>
                      </div>
                    </div>
                    <div class="help-text">Must be unique for a company</div>
                  </div>
                  <div class="col-md-12">
                    <label for="description" class="form-label">Description</label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-clipboard'></i></span>
                      <textarea type="text" class="form-control ps-1" id="description"
                        placeholder="Describe the project details..." rows="2"
                        [ngClass]="{'is-invalid': submitted && p?.description?.errors}" formControlName="description"
                        autocomplete="off"></textarea>
                      <div class="invalid-feedback" *ngIf="submitted && p?.description?.errors">
                        <span *ngIf="p?.description?.errors.required">Please provide a valid description.</span>
                        <span *ngIf="p?.description?.errors.pattern">Description can only contain letters, numbers, and
                          basic
                          punctuation</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="startDate" class="form-label">Start Date<b class="text-secondary">*</b></label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-calendar'></i></span>
                      <input type="date" class="form-control ps-1" id="startDate" formControlName="startDate" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="status" class="form-label">Status</label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                      <ng-select class="form-control rcx-ng-select" formControlName="status"
                        placeholder="Select a Status" [clearable]="false"
                        [ngClass]="{'is-invalid': submitted && p?.status?.errors}">

                        <!-- Dropdown items -->
                        <ng-option *ngFor="let status of statuses" [value]="status">
                          <span [ngClass]="getBadgeClassForStatus(status)">
                            {{ formatStatus(status) }}
                          </span>
                        </ng-option>

                        <!-- Selected item -->
                        <ng-template ng-label-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForStatus(item)">
                            {{ formatStatus(item) }}
                          </span>
                        </ng-template>
                      </ng-select>

                      <div class="invalid-feedback" *ngIf="submitted && p?.status?.errors">
                        <span *ngIf="p?.status?.required">Please select a Status</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="priority" class="form-label">Priority</label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bxs-arrow-to-top'></i></span>
                      <ng-select class="form-control rcx-ng-select" formControlName="priority"
                        placeholder="Select a priority" [clearable]="false"
                        [ngClass]="{'is-invalid': submitted && p?.priority?.errors}">

                        <!-- Dropdown items -->
                        <ng-option *ngFor="let priority of priorities" [value]="priority">
                          <span [ngClass]="getBadgeClassForPriority(priority)">
                            {{ formatPriority(priority) }}
                          </span>
                        </ng-option>

                        <!-- Selected item -->
                        <ng-template ng-label-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForPriority(item)">
                            {{ formatPriority(item) }}
                          </span>
                        </ng-template>
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && p?.priority?.errors">
                        <span *ngIf="p?.priority?.required">Please select a priority</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="teamId" class="form-label">Team<b class="text-secondary">*</b></label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-group'></i></span>
                      <ng-select class="form-control rcx-ng-select" formControlName="teamId" placeholder="Select a team"
                        [ngClass]="{'is-invalid': submitted && p?.teamId?.errors}">
                        <ng-option *ngFor="let team of teams" [value]="team.id">
                          {{team.name}}
                        </ng-option>
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && p?.teamId?.errors">
                        <span *ngIf="p?.teamId?.errors.required">Please select a team</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="teamSize" class="form-label">Team Size <b class="text-secondary">*</b></label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-group'></i></span>
                      <input type="text" class="form-control ps-1" id="teamSize" placeholder="Team size"
                        [ngClass]="{'is-invalid': submitted && p?.teamSize?.errors}" formControlName="teamSize"
                        autocomplete="off" readonly />
                    </div>
                    <div class="help-text">Auto-calculated from team data</div>
                  </div>
                  <div class="col-md-4">
                    <label for="hoursSpent" class="form-label">Hours Spent<b class="text-secondary">*</b></label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-time'></i></span>
                      <input type="text" class="form-control ps-1" id="hoursSpent" placeholder="Hours Spent"
                        [ngClass]="{'is-invalid': submitted && p?.hoursSpent?.errors}" formControlName="hoursSpent"
                        autocomplete="off" readonly />
                    </div>
                    <div class="help-text">Auto-calculated from tasks</div>
                  </div>
                  <div class="col-md-4">
                    <label for="riskLevel" class="form-label">Risk Level</label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0">
                        <i class='bx bx-bar-chart-alt-2'></i>
                      </span>

                      <ng-select class="form-control rcx-ng-select" formControlName="riskLevel"
                        placeholder="Select a risk level" [clearable]="false"
                        [ngClass]="{'is-invalid': submitted && p?.riskLevel?.errors}">

                        <!-- Dropdown options -->
                        <ng-option *ngFor="let riskLevel of riskLevels" [value]="riskLevel">
                          <span [ngClass]="getBadgeClassForRisk(riskLevel)">
                            {{ formatRisk(riskLevel) }}
                          </span>
                        </ng-option>

                        <!-- Selected item display -->
                        <ng-template ng-label-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForRisk(item)">
                            {{ formatRisk(item) }}
                          </span>
                        </ng-template>
                      </ng-select>

                      <!-- Validation -->
                      <div class="invalid-feedback" *ngIf="submitted && p?.riskLevel?.errors">
                        <span *ngIf="p?.riskLevel?.errors?.required">Please select a risk level</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="type" class="form-label">Project Type</label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0">
                        <i class='bx bx-windows'></i>
                      </span>
                      <ng-select class="form-control rcx-ng-select" formControlName="type"
                        placeholder="Select a project type" [clearable]="false"
                        [ngClass]="{'is-invalid': submitted && p?.type?.errors}">

                        <ng-option *ngFor="let type of types" [value]="type">
                          <span [ngClass]="getBadgeClassForType(type)">
                            {{ formatType(type) }}
                          </span>
                        </ng-option>

                        <ng-template ng-label-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForType(item)">
                            {{ formatType(item) }}
                          </span>
                        </ng-template>
                      </ng-select>

                      <div class="invalid-feedback" *ngIf="submitted && p?.type?.errors">
                        <span *ngIf="p?.type?.errors?.required">Please select a project type</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="completionQuality" class="form-label">Completion Quality</label>
                    <div class="input-group">
                      <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-equalizer'></i></span>
                      <ng-select class="form-control rcx-ng-select" formControlName="completionQuality"
                        placeholder="Select a project completion quality" [clearable]="false"
                        [ngClass]="{'is-invalid': submitted && p?.completionQuality?.errors}"
                        [items]="completionQualities">
                        <ng-template ng-option-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForQuality(item)">
                            {{ formatQuality(item) }}
                          </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          <span [ngClass]="getBadgeClassForQuality(item)">
                            {{ formatQuality(item) }}
                          </span>
                        </ng-template>
                      </ng-select>
                      <div class="invalid-feedback" *ngIf="submitted && p?.completionQuality?.errors">
                        <span *ngIf="p?.completionQuality?.errors?.required">Please select a project completion
                          quality</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="progressPercentage" class="form-label">Progress</label>
                    <div class="progress radius-10 h-5 mt-3" data-bs-toggle="tooltip"
                      [title]="projectForm.value?.progressPercentage + '%'">
                      <div class="progress-bar bg-primary" role="progressbar"
                        [style.width.%]="projectForm.value?.progressPercentage"
                        [attr.aria-valuenow]="projectForm.value?.progressPercentage" aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="milestoneCount" class="form-label">Milestone Count</label>
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-dice-2'></i></span>
                      <input type="number" class="form-control ps-1" id="milestoneCount" placeholder="Milestone Count"
                        [ngClass]="{'is-invalid': submitted && p?.milestoneCount.errors}"
                        formControlName="milestoneCount" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-md-auto">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" placement="top" container="body"
                        formControlName="disabled">
                      <label class="form-check-label" for="disabled">Disabled</label>
                    </div>
                  </div>
                  <div class="col-md-auto">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" placement="top" container="body"
                        formControlName="archived">
                      <label class="form-check-label" for="disabled">Archived</label>
                    </div>
                  </div>
                  <!-- <div class="col-md-12 container">
                    <label for="completionQuality" class="form-label">Notes</label>
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="notes" [ngClass]="{'is-invalid': submitted && p.notes.errors}">
                    </ngx-editor>
                  </div> -->
                  <div class="col-md-12 editor mt-3">
                    <label for="notes" class="form-label">Notes</label>
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="notes"
                      [ngClass]="{'is-invalid': submitted && p.notes.errors}">
                    </ngx-editor>
                    <div class="invalid-feedback" *ngIf="submitted && p.notes.errors">
                      <span *ngIf="f.notes.errors.required">Notes is required.</span>
                      <span *ngIf="f.notes.errors.maxlength">Character limit exceeded. Maximum allowed is 2000
                        characters.</span>
                    </div>
                    <!-- <small class="text-muted float-end">
                      {{ milestoneForm.get('notes')?.value?.length || 0 }}/2000
                    </small> -->
                  </div>
                </div>
              </div>
              <div class="modal-footer border-0">
                <button type="submit" class="btn btn-secondary" #inProgress
                  [ngClass]="{'no-event':inProgress?.value=='true'}" id="save-btn">
                  <ng-container *ngIf="inProgress?.value=='true'">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{projectForm.value.id?'Updating...':'Saving...'}}
                  </ng-container>
                  <ng-container *ngIf="inProgress?.value!='true'">
                    <i class="bx bx-save"></i>{{projectForm.value.id?'Save Changes':'Save'}}
                  </ng-container>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div *ngIf="projectForm?.value?.id">
  <app-manage-environment [projectId]="projectId"></app-manage-environment>
</div>
<div class="row btn-mt">
  <div class="col-lg-auto text-start">
    <button class="btn btn-secondary btn-sm" [routerLink]="'/project-pilot/projects'" title="Go Back">
      <i class="bx bx-arrow-back"></i>
    </button>
  </div>
</div>